import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreDataService } from '@common/services/store-data.service';
import { ProgressBarService } from '@components/progress-bar/progress-bar.service';
import { PAGES, PAGES_URLS } from '@constants/pages-config.constants';

@Component({
    selector: 'app-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss'],
    standalone: false,
})
export class SplashScreenComponent implements OnInit, OnDestroy {
    private readonly bodyClass = 'splash-page';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private storeDataService: StoreDataService,
        private renderer: Renderer2,
        private progressBarService: ProgressBarService
    ) {}

    ngOnInit(): void {
        this.renderer.addClass(document.body, this.bodyClass);
        this.progressBarService.changeProgressBarStatus({
            progress: 0,
            completedStep: 0,
            isProgressBarShown: false,
        });

        const queryParams = this.route.snapshot.queryParams;

        if (this.storeDataService.redirectToNewSiteIfNeeded(this.router.url, queryParams)) {
            return;
        }

        this.router.navigate([PAGES_URLS[PAGES.YOUR_CLEAN]], {
            queryParams,
            replaceUrl: true,
        });
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(document.body, this.bodyClass);
    }
}
